import React, { Component } from "react";
import { Collapse, NavDropdown } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import * as Business from "../../utils/business";
import { t, onLangChange } from "../../i18n";

class Nav extends Component {
  state = { 
    _lang: null,
    liquidityV2MenuOpen: false,
    irrbbMenuOpen: false,
  };

  componentDidMount() {
    this._unsubscribe = onLangChange(() =>
      this.setState({ _lang: Date.now() }),
    );
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
  }

  render() {
    return (
      <ul className="nav">
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.CREATE_USER]) && (
          <li
            className={
              this.isPathActive("/dashboard") || this.state.dashboardOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ dashboardOpen: !this.state.dashboardOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-graph"></i>
              <p>
                {t("nav.dashboard")} <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.dashboardOpen}>
              <div>
                <ul className="nav">
                  <li
                    className={
                      this.isPathActive("/dashboard/stats") ? "active" : null
                    }
                  >
                    <Link to="/dashboard/stats">
                      {t("nav.dashboard.stats")}
                    </Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/dashboard/car") ? "active" : null
                    }
                  >
                    <Link to="/dashboard/car">{t("nav.dashboard.car")}</Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/dashboard/credit-risk")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/dashboard/credit-risk">
                      {t("nav.dashboard.creditRisk")}
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CAR_UPLOAD_FILES,
          Business.ROLE_DEFINE_MAP.CAR_VIEW_REPORT,
          Business.ROLE_DEFINE_MAP.CAR_DELETE_REPORT,
        ]) && (
          <li
            className={
              this.isPathActive("/car") || this.state.carMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ carMenuOpen: !this.state.carMenuOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-note2"></i>
              <p>
                {t("nav.car")} <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.carMenuOpen}>
              <div>
                <ul className="nav">
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_UPLOAD_FILES,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/car/upload-file") ? "active" : null
                      }
                    >
                      <Link to="/car/upload-file">{t("nav.car.upload")}</Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_UPLOAD_FILES,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/car/file-management")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/car/file-management">
                        {t("nav.car.fileManagement")}
                      </Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_VIEW_REPORT,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/car/reports") ? "active" : null
                      }
                    >
                      <Link to="/car/reports">{t("nav.car.reports")}</Link>
                    </li>
                  )}
                  {/* {
                      Business.isHasRole([Business.ROLE_DEFINE_MAP.VIEW_REPORT])
                      &&
                      (
                        <li className={this.isPathActive('/car/capitals') ? 'active' : null}>
                          <Link to="/car/capitals">Capitals</Link>
                        </li>
                      )
                    } */}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_SAVE,
          Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_VIEW_REPORT,
          Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_CALCULATE,
          Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_DELETE_REPORT,
        ]) && (
          <li
            className={
              this.isPathActive("/capital-planning") ||
              this.state.capitalPlanningMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({
                  capitalPlanningMenuOpen: !this.state.capitalPlanningMenuOpen,
                })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-graph2"></i>
              <p>
                {t("nav.capitalPlanning")}
                <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.capitalPlanningMenuOpen}>
              <div>
                <ul className="nav">
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_CALCULATE,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/capital-planning/dashboard")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/capital-planning/dashboard">
                        {t("nav.capitalPlanning.dashboard")}
                      </Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_VIEW_REPORT,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/capital-planning/report")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/capital-planning/report">
                        {t("nav.capitalPlanning.report")}
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_UPLOAD_FILES]) && (
          <li
            className={
              this.isPathActive("/icaap") || this.state.icaapMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ icaapMenuOpen: !this.state.icaapMenuOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-cash"></i>
              <p>
                {t("nav.icaap")} <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.icaapMenuOpen}>
              <div>
                <ul className="nav">
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.ICAAP_UPLOAD_FILES,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/icaap/upload-file")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/icaap/upload-file">
                        {t("nav.icaap.upload")}
                      </Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.ICAAP_UPLOAD_FILES,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/icaap/file-management")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/icaap/file-management">
                        {t("nav.icaap.fileManagement")}
                      </Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.ICAAP_VIEW_REPORT,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/icaap/reports") ? "active" : null
                      }
                    >
                      <Link to="/icaap/reports">{t("nav.icaap.reports")}</Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        <li
          className={
            this.isPathActive("/liquidity-ratio") ||
            this.state.liquidityRatioMenuOpen
              ? "active"
              : null
          }
        >
          <a
            onClick={() =>
              this.setState({
                liquidityRatioMenuOpen: !this.state.liquidityRatioMenuOpen,
              })
            }
            data-toggle="collapse"
          >
            <i className="pe-7s-diskette"></i>
            <p>
              Liquidity Ratio <b className="caret"></b>
            </p>
          </a>
          <Collapse in={this.state.liquidityRatioMenuOpen}>
            <div>
              <ul className="nav">
                <li>
                  <a
                    onClick={() =>
                      this.setState({
                        liquidityLCRMenuOpen: !this.state.liquidityLCRMenuOpen,
                      })
                    }
                    data-toggle="collapse"
                  >
                    <p>
                      LCR <b className="caret"></b>
                    </p>
                  </a>
                  <Collapse in={this.state.liquidityLCRMenuOpen}>
                    <div>
                      <ul className="nav">
                        <li
                          className={
                            this.isPathActive("/liquidity-ratio/lcr/upload-file")
                              ? "active"
                              : null
                          }
                        >
                          <Link to="/liquidity-ratio/lcr/upload-file" style={{ paddingLeft: 84 }}>
                            Upload File
                          </Link>
                        </li>
                        <li
                          className={
                            this.isPathActive("/liquidity-ratio/lcr/file-management")
                              ? "active"
                              : null
                          }
                        >
                          <Link to="/liquidity-ratio/lcr/file-management" style={{ paddingLeft: 84 }}>
                            File Management
                          </Link>
                        </li>
                        <li
                          className={
                            this.isPathActive("/liquidity-ratio/lcr/reports")
                              ? "active"
                              : null
                          }
                        >
                          <Link to="/liquidity-ratio/lcr/reports" style={{ paddingLeft: 84 }}>
                            Reports
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Collapse>
                </li>
                <li>
                  <a
                    onClick={() =>
                      this.setState({
                        liquidityNFSRMenuOpen: !this.state.liquidityNFSRMenuOpen,
                      })
                    }
                    data-toggle="collapse"
                  >
                    <p>
                      NSFR <b className="caret"></b>
                    </p>
                  </a>
                  <Collapse in={this.state.liquidityNFSRMenuOpen}>
                    <div>
                      <ul className="nav">
                        <li
                          className={
                            this.isPathActive("/liquidity-ratio/nfsr/upload-file")
                              ? "active"
                              : null
                          }
                        >
                          <Link to="/liquidity-ratio/nfsr/upload-file" style={{ paddingLeft: 84 }}>
                            Upload File
                          </Link>
                        </li>
                        <li
                          className={
                            this.isPathActive("/liquidity-ratio/nfsr/file-management")
                              ? "active"
                              : null
                          }
                        >
                          <Link to="/liquidity-ratio/nfsr/file-management" style={{ paddingLeft: 84 }}>
                            File Management
                          </Link>
                        </li>
                        <li
                          className={
                            this.isPathActive("/liquidity-ratio/nfsr/reports")
                              ? "active"
                              : null
                          }
                        >
                          <Link to="/liquidity-ratio/nfsr/reports" style={{ paddingLeft: 84 }}>
                            Reports
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Collapse>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        <li
          className={
            this.isPathActive("/irrbb") || this.state.irrbbMenuOpen ? "active" : null
          }
        >
          <a
            onClick={() => this.setState({ irrbbMenuOpen: !this.state.irrbbMenuOpen })}
            data-toggle="collapse"
          >
            <i className="pe-7s-graph2"></i>
            <p>
              IRRBB (RRLSSNH) <b className="caret"></b>
            </p>
          </a>
          <Collapse in={this.state.irrbbMenuOpen}>
            <div>
              <ul className="nav">
                <li className={this.isPathActive("/irrbb/upload") ? "active" : null}>
                  <Link to="/irrbb/upload">Upload File</Link>
                </li>
                <li className={this.isPathActive("/irrbb/file-management") ? "active" : null}>
                  <Link to="/irrbb/file-management">File Management</Link>
                </li>
                <li className={this.isPathActive("/irrbb/reports") ? "active" : null}>
                  <Link to="/irrbb/reports">Reports</Link>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.EDIT_PARAMETERS]) && (
          <li
            className={
              this.isPathActive("/master-table") ||
              this.state.masterTableMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({
                  masterTableMenuOpen: !this.state.masterTableMenuOpen,
                })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-plugin"></i>
              <p>
                {t("nav.masterTable")} <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.masterTableMenuOpen}>
              <div>
                <ul className="nav">
                  <li
                    className={
                      this.isPathActive("/master-table/party-type")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/master-table/party-type">
                      {t("nav.masterTable.partyType")}
                    </Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/master-table/business-sector")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/master-table/business-sector">
                      {t("nav.masterTable.businessSector")}
                    </Link>
                  </li>
                  {/* <li className={this.isPathActive('/master-table/loan-purpose-type') ? 'active' : null}>
                      <Link to="/master-table/loan-purpose-type">Loan Purpose Type</Link>
                    </li>
                    <li className={this.isPathActive('/master-table/collateral-master') ? 'active' : null}>
                      <Link to="/master-table/collateral-master">Collateral Master</Link>
                    </li>
                    <li className={this.isPathActive('/master-table/other-assets') ? 'active' : null}>
                      <Link to="/master-table/other-assets">Other Assets</Link>
                    </li> */}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.NO_ROLE]) && (
          <li
            className={
              this.isPathActive("/raroc") || this.state.rarocMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ rarocMenuOpen: !this.state.rarocMenuOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-calculator"></i>
              <p>
                {t("nav.raroc")} <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.rarocMenuOpen}>
              <div>
                <ul className="nav">
                  <li
                    className={
                      this.isPathActive("/raroc/upload-file") ? "active" : null
                    }
                  >
                    <Link to="/raroc/upload-file">{t("nav.raroc.upload")}</Link>
                  </li>
                  {/* <li className={this.isPathActive('/raroc/dashboard') ? 'active' : null}>
                      <Link to='/raroc/dashboard'>Dashboard</Link>
                    </li> */}
                  <li
                    className={
                      this.isPathActive("/raroc/reports") ? "active" : null
                    }
                  >
                    <Link to="/raroc/reports">{t("nav.raroc.reports")}</Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/raroc/file-management")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/raroc/file-management">
                      {t("nav.raroc.fileManagement")}
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.NO_ROLE]) && (
          <li
            className={
              this.isPathActive("/pricing") || this.state.pricingMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ pricingMenuOpen: !this.state.pricingMenuOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-calculator"></i>
              <p>
                {t("nav.pricing")} <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.pricingMenuOpen}>
              <div>
                <ul className="nav">
                  <li
                    className={
                      this.isPathActive("/pricing/upload") ? "active" : null
                    }
                  >
                    <Link to="/pricing/upload">{t("nav.pricing.upload")}</Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/pricing/file-management")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/pricing/file-management">
                      {t("nav.pricing.fileManagement")}
                    </Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/pricing/processing") ? "active" : null
                    }
                  >
                    <Link to="/pricing/processing">
                      {t("nav.pricing.processing")}
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.DISABLE]) && (
          <li
            className={
              this.isPathActive("/config") || this.state.configMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ configMenuOpen: !this.state.configMenuOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-config"></i>
              <p>
                {t("nav.configParameters")} <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.configMenuOpen}>
              <div>
                <ul className="nav">
                  <li
                    className={
                      this.isPathActive("/config/components") ? "active" : null
                    }
                  >
                    <Link to="/config/components">
                      {t("nav.configParameters.components")}
                    </Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/config/asset-class") ? "active" : null
                    }
                  >
                    <Link to="/config/asset-class">
                      {t("nav.configParameters.assetClass")}
                    </Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/config/risk-weight") ? "active" : null
                    }
                  >
                    <Link to="/config/risk-weight">
                      {t("nav.configParameters.riskWeight")}
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CREATE_USER,
          Business.ROLE_DEFINE_MAP.UPDATE_USER,
          Business.ROLE_DEFINE_MAP.DELETE_USER,
        ]) && (
          <li className={this.isPathActive("/user") ? "active" : null}>
            <Link to="/user">
              <i className="pe-7s-users"></i>
              <p>{t("nav.user")}</p>
            </Link>
          </li>
        )}
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CREATE_ROLE,
          Business.ROLE_DEFINE_MAP.UPDATE_ROLE,
        ]) && (
          <li className={this.isPathActive("/role") ? "active" : null}>
            <Link to="/role">
              <i className="pe-7s-id"></i>
              <p>{t("nav.role")}</p>
            </Link>
          </li>
        )}
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CREATE_ROLE,
          Business.ROLE_DEFINE_MAP.UPDATE_ROLE,
        ]) && (
          <li
            className={
              this.isPathActive("/report-permission") ? "active" : null
            }
          >
            <Link to="/report-permission">
              <i className="pe-7s-lock"></i>
              <p>{t("nav.reportAccess")}</p>
            </Link>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.NO_ROLE]) && (
          <li className={this.isPathActive("/activities") ? "active" : null}>
            <Link to="/activities">
              <i className="pe-7s-target"></i>
              <p>{t("nav.activities")}</p>
            </Link>
          </li>
        )}
      </ul>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
}

export default withRouter(Nav);



// WEBPACK FOOTER //
// src/components/SideBar/Nav.js